import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_URL || "/api";

/**
 * Axios instance configuration
 * Base HTTP client for all API calls
 */
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30000,
});

/**
 * Request interceptor
 * Adds auth token to requests if available
 */
apiClient.interceptors.request.use(
  (config) => {
    // Skip if auth explicitly disabled or if Authorization header already set
    if (config.requiresAuth === false || config.headers.Authorization) {
      return config;
    }

    // Get token from session storage
    const token = sessionStorage.getItem("contract_token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * Response interceptor
 * Handles response data extraction and error formatting
 */
apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const errorData = error.response?.data?.error || {
      code: "NETWORK_ERROR",
      message: "שגיאת רשת. אנא בדוק את החיבור שלך.",
    };

    // Handle token expiration
    if (error.response?.status === 401) {
      sessionStorage.removeItem("contract_token");
    }

    return Promise.reject(errorData);
  }
);

export default apiClient;
